import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

import { FaIconComponent } from '../../atoms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'orbit-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, FaIconComponent],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
  type = input<'checkbox' | 'radio'>('checkbox');
  label = input<string>();
  id = input<string>();
  name = input<string>();
  value = input<string>();
  defaultController = new FormControl<string | null>(null);
  controller = input<FormControl>(this.defaultController);

  readonly checkmark = faCheck;
}
